module.exports = __webpack_public_path__ + "static/img/logo.514c0cca.svg";